import React from 'react'
import { usePrinterExtraStore } from '../../state/storePrinterExtra';
import { usePostMeta } from '../../hooks/usePostMeta';

type Props = {}

const PrinterEnableSave = (props: Props) => {

    const { appendDataPost } = usePostMeta();

  const {
    updateprinter_boolean,
    printer_left1,
    printer_left2,
    printer_left3,
    printer_left4,
    printer_left5,
    printer_left6,
    printer_left7,
    printer_right1,
    printer_right2,
    printer_right3,
    printer_right4,
    printer_right5,
    printer_right6,
    printer_right7,
    printer_boolean,
    printer_logo,
  } = usePrinterExtraStore((state) => state);

  const savePrinterExtra = () => {
    const data = {
      meta: "printer",
      value: {
        printer_left1,
        printer_left2,
        printer_left3,
        printer_left4,
        printer_left5,
        printer_left6,
        printer_left7,
        printer_right1,
        printer_right2,
        printer_right3,
        printer_right4,
        printer_right5,
        printer_right6,
        printer_right7,
        printer_boolean,
        printer_logo,
      },
    };
    appendDataPost(data);
  };
  return (
<div className="">

        <button
          onClick={() => savePrinterExtra()}
          className=" px-4 py-1 mx-4 rounded-sm text-base text-white bg-green-500"
        >
          Save Printer
        </button>
        <input
          type="checkbox"
          onChange={() => updateprinter_boolean(!printer_boolean)}
          checked={printer_boolean}
          name="false"
          id=""
        />
      </div>  )
}

export default PrinterEnableSave